import Vue from 'vue'
import Vuex from 'vuex'
import UnitService from '@/services/UnitService.js'
import Router from './router.js'
import Constants from './constants.js'
import FilterLabelService from '@/services/FilterLabelService.js'

Vue.use(Vuex)
const initialFilter = () => {
  return {
    filters: [],
    latitude: 0,
    longitude: 0,
    place: '',
    placeObject: undefined,
    placeType: Constants.PlaceTypes.Unspecified,
    radius: 20,
    sorting: 0,
    priceFrom: 500,
    priceTo: 9999,
    language: 'nl',
  }
}

let sortTypes = () => {
  if (typeof global.vesteda.settings !== 'undefined') {
    return global.vesteda.settings.sortTypes
  }
}

export default new Vuex.Store({
  state: {
    filter: initialFilter(),
    results: {},
    loaded: false,
    isLoading: false,
    autocompleteOptions: [],
    autocompleteError: undefined,
    unitTypes: [],
    mapVisible: false,
    flyInVisible: false,
    isBlocked: false,
    sortTypes: sortTypes(),
    subscriptions: [],
    otherOptions: [
      {
        name: 'isShareable',
        value: 'isShareable',
        label: global.vesteda.labels.suitedForHomeSharersCheckboxLabel,
      },
    ],
  },
  mutations: {
    UPDATE_LOADING_STATE(state, isLoading) {
      state.isLoading = isLoading
    },
    UPDATE_UNITS(state, results) {
      /* if (results.results.sortType === 0) {
        results.results.items.forEach((element) => {
          element.isActive = false
        })
      } */

      state.results = results
      state.loaded = true
    },
    UPDATE_PLACE(state, placeObject) {
      if (placeObject) {
        state.filter.place = placeObject.name
        state.filter.placeObject = placeObject
        state.filter.latitude = placeObject.lat
        state.filter.longitude = placeObject.lng
        state.filter.placeType = placeObject.type
      } else {
        state.filter.place = ''
        state.filter.placeObject = undefined
        state.filter.latitude = 0
        state.filter.longitude = 0
        state.filter.placeType = Constants.PlaceTypes.Unspecified
      }
    },
    UPDATE_PLACE_QUERY(state, query) {
      state.filter.place = query
    },
    UPDATE_PLACE_OBJECT(state, object) {
      state.filter.placeObject = object
    },
    UPDATE_PLACE_OBJECT_KEY(state, object) {
      if (!state.filter.placeObject) {
        state.filter.placeObject = {}
      }
      state.filter.placeObject = Object.assign(state.filter.placeObject, object)
    },
    UPDATE_PRICE(state, payload) {
      state.filter.priceTo = payload.priceTo
      state.filter.priceFrom = payload.priceFrom
    },
    UPDATE_PRICE_FROM(state, payload) {
      state.filter.priceFrom = Number(payload)
    },
    UPDATE_PRICE_TO(state, payload) {
      state.filter.priceTo = Number(payload)
    },
    UPDATE_SORT_TYPE(state, type) {
      state.filter.sorting = type
    },
    UPDATE_LAT(state, payload) {
      state.filter.latitude = payload
    },
    UPDATE_LNG(state, payload) {
      state.filter.longitude = payload
    },
    UPDATE_PLACETYPE(state, payload) {
      state.filter.placeType = payload
    },
    UPDATE_RADIUS(state, radius) {
      state.filter.radius = radius
    },
    UPDATE_FILTERS(state, filters) {
      const filtersArray = filters.split(',').map(Number)
      state.filter.filters = filtersArray
    },
    UPDATE_LANGUAGE(state, language) {
      state.filter.language = language
    },
    UPDATE_AUTOCOMPLETE_OPTIONS(state, options) {
      state.autocompleteOptions = options
    },
    UPDATE_AUTOCOMPLETE_ERROR(state, payload) {
      state.autocompleteError = payload
    },
    TOGGLE_MAP(state) {
      state.mapVisible = !state.mapVisible
    },
    TOGGLE_FLYIN(state) {
      state.flyInVisible = !state.flyInVisible
    },
    RESET_FILTERS(state) {
      state.filter = initialFilter()
    },
    SET_SUBSCRIPTIONS(state, subscriptions) {
      state.subscriptions = subscriptions
    },
  },
  actions: {
    /* GLOBAL LOGIC */
    setInitialFilter({ commit }) {
      const query = Router.currentRoute.query

      // set language
      commit('UPDATE_LANGUAGE', Router.currentRoute.path.split('/')[1])

      Object.keys(query).forEach((key) => {
        const queryObject = {}
        queryObject[key] = query[key]
        switch (key) {
          case 'filters':
            commit('UPDATE_FILTERS', query.filters)
            break
          case 'latitude':
            commit('UPDATE_PLACE_OBJECT_KEY', queryObject)
            commit('UPDATE_LAT', parseFloat(query.latitude))
            break
          case 'longitude':
            commit('UPDATE_PLACE_OBJECT_KEY', queryObject)
            commit('UPDATE_LNG', parseFloat(query.longitude))
            break
          case 'lat':
            commit('UPDATE_PLACE_OBJECT_KEY', queryObject)
            commit('UPDATE_LAT', parseFloat(query.lat))
            break
          case 'lng':
            commit('UPDATE_PLACE_OBJECT_KEY', queryObject)
            commit('UPDATE_LNG', parseFloat(query.lng))
            break
          case 'placeType':
            commit('UPDATE_PLACE_OBJECT_KEY', queryObject)
            commit('UPDATE_PLACETYPE', parseInt(query.placeType))
            break
          case 'radius':
            commit('UPDATE_RADIUS', parseInt(query.radius))
            break
          case 's':
            commit('UPDATE_PLACE_QUERY', query.s)
            commit('UPDATE_PLACE_OBJECT_KEY', { name: query.s })
            break
          case 'sortType':
            commit('UPDATE_SORT_TYPE', parseInt(query.sortType))
            break
          case 'priceFrom':
            commit('UPDATE_PRICE_FROM', query.priceFrom)
            break
          case 'priceTo':
            commit('UPDATE_PRICE_TO', query.priceTo)
            break
          default:
            // unspecified key
            return
        }
      })
    },

    /* FILTER UPDATES */
    updatePlace({ commit, dispatch }, place) {
      commit('UPDATE_PLACE', place)
      if (place) {
        dispatch('trackSearchChange', 'place ' + place.name)
      }
    },
    updateRadius({ commit, dispatch }, radius) {
      if (radius > 200) {
        radius = 200
      }
      commit('UPDATE_RADIUS', radius)
      dispatch('trackSearchChange', 'radius ' + radius + 'km')
    },
    updatePriceTo(context, value) {
      context.commit('UPDATE_PRICE_TO', value)
      //context.dispatch('trackPriceChange', { name: 'price to', value })
    },
    updatePriceFrom(context, value) {
      context.commit('UPDATE_PRICE_FROM', value)
      //context.dispatch('trackPriceChange', { name: 'price from', value })
    },
    updateFilters(context, values) {
      const filters = this.state.filter.filters

      if (values.remove) {
        const index = filters.indexOf(values.remove)
        if (index > -1) filters.splice(index, 1)
      }
      if (values.add) filters.push(values.add)

      context.commit('UPDATE_FILTERS', filters.toString())
      //context.dispatch('trackFilterChange', values)
      
      localStorage.setItem('last_interacted', 'filter update')
    },

    /* API CALLS */
    getUnits(context) {
      if (global.vesteda.onlyFilter) {
        return
      }
      context.commit('UPDATE_LOADING_STATE', true)
      return UnitService.getUnits(this.state.filter).then((response) => {
        context.commit('UPDATE_UNITS', response.data)

        let query = context.getters.query
        // Don't fire searchevent when sort has been changed. In all other cases do.
        if(localStorage.getItem('sortChange') != 1) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'search',
          sc: 'woning',
          s: query,
          amountResults: response.data.count,
          search_type: localStorage.getItem('last_interacted'),
        })
      }
        localStorage.setItem('sortChange',0)
        localStorage.setItem('last_interacted', '')
        localStorage.setItem('last_query', JSON.stringify(query))
        Router.push({ query: query }).catch(()=>{ } );
        window.dataLayer.push({
          event: 'pageChanged',
          newUrl: window.location.href,
        })

        context.commit('UPDATE_LOADING_STATE', false)
      })
    },
    getAutoCompleteOptions({ state, commit }, query) {
      return UnitService.getAutoCompleteOptions(query).then((response) => {
        if (response.data.length === 0 && state.filter.place.length > 2) {
          commit('UPDATE_AUTOCOMPLETE_ERROR', {
            message: 'AUTO COMPLETE ERROR',
          })
        } else {
          commit('UPDATE_AUTOCOMPLETE_ERROR')
        }
        commit('UPDATE_AUTOCOMPLETE_OPTIONS', response.data)
      })
    },

    /* OTHER */
    submitForm({ dispatch, getters }) {
      if (getters.submitIsDisabled) {
        return
      }
      dispatch('executeSearch')
    },
    executeSearch({ getters }) {
      let query = getters.query
      Router.push({ query: query })
      window.location.assign(global.vesteda.baseUrl + window.location.search)
    },
    toggleMap({ commit }) {
      commit('TOGGLE_MAP')
    },
    toggleFlyIn({ commit }) {
      commit('TOGGLE_FLYIN')
    },
    clearFilters({ commit, dispatch }) {
      commit('RESET_FILTERS')
      dispatch('getUnits')
    },
    executeLastSearch(context) {
      let query = context.getters.savedSearch
      Router.push({ query: query })
      window.location.assign(global.vesteda.baseUrl + window.location.search)
    },

    /* GTM */
    trackSearchChange(context, value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'action',
        eventCategory: 'search',
        eventAction: 'search_filter',
        eventLabel: value,
      })
    },
    trackFilterChange(context, values) {
      const filterChanges = FilterLabelService.filterIdToGTM(values)
      window.dataLayer = window.dataLayer || []

      filterChanges.map((filterChange) => {
        window.dataLayer.push({
          event: 'filter_interaction',
          filter_name: filterChange.name,
          filter_value: filterChange.value,
          filter_setting: filterChange.setting,
        })
      })
    },
    trackPriceChange(context, value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'filter_interaction',
        filter_name: value.name,
        filter_value: value.value,
        filter_setting: null,
      })
    },

    /* get subscriptions from local storage */
    getSubscriptions({ commit }) {
      let subscriptions = []
      if (window.localStorage.getItem('subscriptions_1.1')) {
        try {
          subscriptions = JSON.parse(
            window.localStorage.getItem('subscriptions_1.1')
          )
        } catch (e) {
          subscriptions = []
        }
      }
      commit('SET_SUBSCRIPTIONS', subscriptions)
    },

    /* event listener for update in localstorage */
    listenForSubscriptionsUpdate() {
      window.addEventListener('SubscriptionsUpdate', () => {
        this.dispatch('getSubscriptions')
      })
    },
  },
  getters: {
    unitResults: (state) => {
      return state.results.results.objectsCount ? state.results.results.objectsCount : 0
    },
    totalResults: (state) => {
      return state.results.count ? state.results.count : 0
    },
    units: (state) => {
      return state.results.results
    },
    query: (state) => {
      const query = {}
      query.placeType = state.filter.placeType
      query.sortType = state.filter.sorting
      query.radius = state.filter.radius
      query.s = state.filter.place
      query.sc = 'woning'
      query.latitude = state.filter.latitude
      query.longitude = state.filter.longitude
      query.filters = state.filter.filters.toString()
      query.priceFrom = state.filter.priceFrom
      query.priceTo = state.filter.priceTo
      return query
    },
    submitIsDisabled: (state) => {
      return !state.filter.placeObject && state.filter.place.length > 0
    },
    savedSearch: () => {
      // TODO: this is not state
      var search = localStorage.getItem('last_query')

      if (search && search !== '') {
        return JSON.parse(search)
      }
      return null
    },
  },
})
